import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe do konwersji enum typu dokumentu na czytelną nazwę
 * Przykład: 'FakturaVAT' -> 'Faktura VAT'
 */
@Pipe({
  name: 'documentTypeName',
  standalone: true
})
export class DocumentTypeNamePipe implements PipeTransform {

  private static readonly TYPE_NAMES: Record<string, string> = {
    // Nowe typy z unified document store
    'Faktura': 'Faktura VAT',
    'FakturaZaliczkowa': 'Faktura zaliczkowa',
    'FakturaKoncowa': 'Faktura końcowa',
    'FakturaMarza': 'Faktura marża',
    'Proforma': 'Proforma',
    'WZ': 'Wydanie zewnętrzne (WZ)',
    'PZ': 'Przyjęcie zewnętrzne (PZ)',
    'Zamowienie': 'Zamówienie',
    // Starsze typy (kompatybilność)
    'FakturaVAT': 'Faktura VAT',
    'FakturaProforma': 'Faktura proforma',
    'FakturaBezVAT': 'Faktura bez VAT',
    'FakturaProformaBezVAT': 'Faktura proforma bez VAT',
    'FakturaKorygujaca': 'Faktura korygująca',
    'FakturaKorygujacaZaliczkowa': 'Korekta faktury zaliczkowej',
    'FakturaKorygujacaRozliczeniowa': 'Korekta faktury rozliczeniowej',
    'FakturaZaliczka': 'Faktura zaliczkowa',
    'FakturaRozliczeniowa': 'Faktura rozliczeniowa',
    'FakturaVATMarza': 'Faktura VAT marża',
    'FakturaVATMarzaProforma': 'Faktura VAT marża proforma',
    'FakturaUproszczona': 'Faktura uproszczona',
    'Rachunek': 'Rachunek',
    // Kody KSeF
    'VAT': 'Faktura VAT',
    'KOR': 'Faktura korygująca',
    'ZAL': 'Faktura zaliczkowa',
    'ROZ': 'Faktura rozliczeniowa',
    'UPR': 'Faktura uproszczona',
    'KOR_ZAL': 'Korekta faktury zaliczkowej',
    'KOR_ROZ': 'Korekta faktury rozliczeniowej',
  };

  transform(value: string | null | undefined): string {
    if (!value) {
      return 'Nieznany typ';
    }
    
    return DocumentTypeNamePipe.TYPE_NAMES[value] || value;
  }

  /**
   * Statyczna metoda do użycia poza template'ami
   */
  static getName(type: string | null | undefined): string {
    if (!type) {
      return 'Nieznany typ';
    }
    return DocumentTypeNamePipe.TYPE_NAMES[type] || type;
  }
}
